export const getMesAddress = state => state.mesAddress.address;
export const getError = state => state.mesAddress.error;
export const getStatus = state => state.mesAddress.status;
export const getMesAddressSend = state => state.mesAddress.mesAddressSend;
export const getUser = state => state.account.userInfo;